/**
 * Checks for an optional `+`, a 1 to 4 digit country part, then at least 8 more digits,
 * each optionally preceded by one space. Example: `+41 79 123 45 67` is valid.
 */
export function isPhoneNumberValid(phoneNumber: string): boolean {
  const pattern: RegExp = /^\+?\d{1,4}(\s?\d){8,}$/;
  return pattern.test(phoneNumber);
}
